import { CanActivateAppointmentPageGuard } from "./can-activate-appointment-page.guard";

export const APPOINTMENT_GUARDS: any[] = [
    CanActivateAppointmentPageGuard
];

export * from "./can-activate-appointment-page.guard";


